/**
 * @generated SignedSource<<b7c2f5f41fe2b3e52600cd4b81fe6528>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type auth_needsAccountSetup$data = {
  readonly confirmedEmail: boolean | null | undefined;
  readonly guest: boolean;
  readonly passwordSetupRequired: boolean | null | undefined;
  readonly " $fragmentType": "auth_needsAccountSetup";
};
export type auth_needsAccountSetup$key = {
  readonly " $data"?: auth_needsAccountSetup$data;
  readonly " $fragmentSpreads": FragmentRefs<"auth_needsAccountSetup">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "auth_needsAccountSetup"
};

(node as any).hash = "332cd5a0e5f3d3f217ff5b5eb1f81830";

export default node;
